import { QueryParams } from './query-params';

const queryParams = new QueryParams();

function changeUrlIfMerged(modelId: number) {
    let path = location.pathname;
    const splitted = path.split('/');
    const id = parseInt(splitted.pop() ?? '');
    if (id !== modelId) {
        splitted.push(modelId.toString());
        path = splitted.join('/');
        const newUrl = location.protocol + '//' + location.host + path;
        window.history.pushState({ path: newUrl }, '', newUrl);
    }
}

function currentPageData() {
    const [entityId, entityPage] = location.pathname.split('/').filter(String).reverse();
    const data = { entityPage, entityId };

    if (data.entityId.toLowerCase().includes('favorite')) {
        data.entityPage = data.entityId;
        data.entityId = '0';
    }
    return data;
}

window.changeUrlIfMerged = changeUrlIfMerged;
window.currentPageData = currentPageData;
window.getQueryParams = () => queryParams.get();
window.getSettings = () => queryParams.getSettings();
window.getSchedulerSettings = () => queryParams.getSchedulerSettings();
window.getId = () => queryParams.getId();
